import './registrationConfirmation.scoped.scss'
import { PrimaryButton } from "components/common/buttons/primaryButton/primaryButton"

export interface RegistrationConfirmationProps {
  onClickSignIn: () => void
}

export const RegistrationConfirmation = (props: RegistrationConfirmationProps) => {
  return (
    <div className="registration-confirmation column gap4" role="status">
      <p>Brukeren er registrert og venter på godkjenning fra en administrator.</p>
      <p>Du kan logge inn når brukeren er godkjent.</p>
      <div className="column">
        <PrimaryButton onClick={props.onClickSignIn}>Til innlogging</PrimaryButton>
      </div>
    </div>
  )
}
